export enum ProcessStatus {
  DRAFT = 'DRAFT',
  SENT = 'SENT',
  IN_PROGRESS = 'IN_PROGRESS',
  FINISHED = 'FINISHED',
  REJECTED = 'REJECTED',
  TRANSMITTED = 'TRANSMITTED',
  TRANSMISSION_FAILED = 'TRANSMISSION_FAILED',
  DECLINED = 'DECLINED',
  APPROVED = 'APPROVED',
  OLD = 'OLD',
  CANCELED = 'CANCELED',
  CANCELED_AFTER_APPROVED = 'CANCELED_AFTER_APPROVED',
  UNKNOWN = 'UNKNOWN'
}
